import styled from "styled-components";

export const StyleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background: #2a3b5c;
  @media screen and (max-width: 670px) {
    flex-direction: column;
  }
`;

export const MainContent = styled.div`
  margin: 1rem 0 1rem 5rem;
  @media screen and (max-width: 1024px) {
    margin: 1rem 0 1rem 3rem;
  }
  @media screen and (max-width: 670px) {
    margin: 1rem 0 1rem 2rem;
  }
`;
export const StyleForm = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(auto, minmax(3rem, 1fr));
  grid-template-areas:
    "header header ."
    "name message message"
    "email message message"
    "other sendmessage sendmessage";

  grid-row-gap: 1.5rem;
  grid-column-gap: 3rem;
  @media screen and (max-width: 1024px) {
    grid-column-gap: 1.5rem;
  }
  @media screen and (max-width: 670px) {
    display: flex;
    flex-direction: column;
  }

  div:nth-of-type(1) {
    grid-area: header;
  }
  div:nth-of-type(2) {
    grid-area: name;
  }
  div:nth-of-type(3) {
    grid-area: email;
  }
  div:nth-of-type(4) {
    grid-area: other;
  }
  div:nth-of-type(5) {
    grid-area: message;
  }
  div:nth-of-type(6) {
    grid-area: sendmessage;
  }

  div.name,
  div.email {
    height: 4rem;
    letter-spacing: 0.09rem;
    input {
      margin-top: 7px;
      width: 100%;
      height: 2.5rem;
      padding-left: 0.3rem;
      border: 3px solid #8f6e25;
      background: #193549;
      outline: none;
      color: #a86d3d;
      @media screen and (max-width: 670px) {
        width: 70%;
      }
    }
  }
`;
export const FooterTop = styled.div`
  font-size: 3rem;
  line-height: 1.2;
  letter-spacing: 0.09rem;
  color: #dbb765;
  font-weight: bold;
  padding: 0.5rem;
  @media screen and (max-width: 970px) {
    font-size: 2rem;
  }
  @media screen and (max-width: 670px) {
    font-size: 3rem;
  }
  @media screen and (max-width: 490px) {
    font-size: 2rem;
  }
  span {
    opacity: 0.6;
    display: block;
    font-size: 1rem;
    @media screen and (max-width: 970px) {
      font-size: 0.7rem;
    }
    @media screen and (max-width: 670px) {
      font-size: 0.9rem;
    }
    @media screen and (max-width: 490px) {
      font-size: 0.7rem;
    }
  }
`;
export const RadioStyles = styled.div`
  div.radioBtns {
    margin: 0.5rem 0 0;
    color: #a86d3d;
    padding: 0.5rem 0;

    label {
      margin-left: 0.3rem;
      span {
        padding-left: 0.2rem;
      }
    }
  }
  div.otherReason {
    input {
      width: 100%;
      height: 2.5rem;
      padding-left: 0.3rem;
      border: 3px solid #8f6e25;
      background: #193549;
      outline: none;
      color: #a86d3d;
      @media screen and (max-width: 670px) {
        width: 70%;
      }
    }
  }
`;
export const StyleMessage = styled.div`
  div {
    letter-spacing: 0.09rem;
    margin-bottom: 0.2rem;
  }
  textarea {
    height: 100%;
    width: 70%;
    padding: 0.3rem 0.3rem;
    font-size: 1.1rem;
    outline: none;
    border: none;
    border: 3px solid #8f6e25;
    background: #193549;
    outline: none;
    color: #a86d3d;
  }
`;
export const StyleBtn = styled.div`
  margin-top: 18px;
  button {
    width: 70%;
    height: 70%;
    background: #193549;
    align-self: end;
    color: #dbb765;
    border: 5px solid #8f6e25;
    transition: all 0.3s ease-in-out;
    div {
      font-size: 1.5rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 0.5rem;
      @media screen and (max-width: 670px) {
        font-size: 1.2rem;
      }
    }
    @media screen and (max-width: 670px) {
      height: 2.5rem;
    }
    &:hover {
      background: #8f6e25;
      color: #193549;
      cursor: pointer;
    }
  }
`;
export const StyleAside = styled.ul`
  margin: 3rem 5rem 1.5rem 3rem;
  display: flex;
  justify-content: space-between;
  align-items: space-between;
  flex-direction: column;
  opacity: 0.5;
  color: #e0c59f;
  @media screen and (max-width: 1024px) {
    margin: 3rem 1rem 1.5rem 1rem;
  }
  @media screen and (max-width: 670px) {
    flex-direction: row;
  }
  @media screen and (max-width: 490px) {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-gap: 0.5rem;
  }
  li.otherOptions {
    a {
      text-decoration: none;
      color: #e0c59f;

      @media screen and (max-width: 1024px) {
        font-size: 0.8rem;
      }
      @media screen and (max-width: 670px) {
        font-size: 0.7rem;
        list-style: none;
      }
      @media screen and (max-width: 600px) {
        margin: 0 0.5rem;
      }
      :hover {
        cursor: pointer;
        color: #8f6e25;
      }
    }
  }
`;
export const StyleSocialbtns = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  a {
    text-decoration: none;
    color: #e0c59f;
    svg {
      font-size: 1.5rem;
      @media screen and (max-width: 1024px) {
        font-size: 1.2rem;
      }
      :hover {
        cursor: pointer;
        color: #2bc6de;
      }
    }
  }
`;
export const StyleFooterEnd = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3rem;
  background: #2a3b5c;
  width: 100%;
  border-top: 5px solid #193549;
  @media screen and (max-width: 490px) {
    font-size: 0.7rem;
  }
  div.copyright {
    margin: 0 1rem;
    color: #e0c59f;
    font-weight: bold;
  }
  div.Top {
    margin: 0 1rem;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #e0c59f;
    font-weight: bold;
    a {
      text-decoration: none;
      color: #d99696;
      span:nth-of-type(2) {
        display: none;
        @media screen and (max-width: 765px) {
          display: block;
          font-size: 2rem;
        }
      }
      @media screen and (max-width: 765px) {
        span:nth-of-type(1) {
          display: none;
        }
      }
    }
  }
`;
